module.exports = __webpack_public_path__ + "img/operationSteps.8e66ae42.png";